import React from 'react';
import { FsDirection } from 'globals/types';
import useTheme from '@material-ui/core/styles/useTheme';
import { purple } from 'globals/colors';

interface FsVectorArrowIconProps {
  color?: string;
  direction?: FsDirection;
  disabled?: boolean;
}

const getRotationDegree = (direction: FsDirection): string => {
  switch (direction) {
    case FsDirection.RIGHT:
      return '0deg';
    case FsDirection.DOWN:
      return '90deg';
    case FsDirection.LEFT:
      return '180deg';
    case FsDirection.UP:
      return '270deg';
    default:
      return '0deg';
  }
};

const FsVectorArrowIcon: React.FC<FsVectorArrowIconProps> = ({
  color = purple.BRAND,
  direction = FsDirection.RIGHT,
  disabled,
}) => {
  const { palette } = useTheme();
  const activeColor = disabled ? palette.grey[200] : color;
  const rotationDegree = getRotationDegree(direction);
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: `rotate(${rotationDegree})`,
      }}
    >
      <path
        d="M5 1L11.4848 7.48483L5 13.9697"
        stroke={activeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FsVectorArrowIcon;
